<template>
  <div class="container">
    <div class="form-wrapper">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="140px" label-position="right" class="demo-ruleForm" hide-required-asterisk>
        <el-form-item label="文章链接" prop="articleUrl">
          <el-input v-model.trim="ruleForm.articleUrl" placeholder="请输入..." maxlength="249" />
        </el-form-item>
        <el-form-item label="文章标题" prop="articleTitle">
          <el-input v-model.trim="ruleForm.articleTitle" placeholder="请输入..." maxlength="249" />
        </el-form-item>
        <el-form-item label="来源类型" prop="sourceType">
          <el-select v-model="ruleForm.sourceType" placeholder="请选择来源类型">
            <el-option label="网站" value="0" />
            <el-option label="APP" value="1" />
            <el-option label="微博" value="2" />
            <el-option label="微信" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="文章来源" prop="articleSource" maxlength="249">
          <el-input v-model.trim="ruleForm.articleSource" placeholder="请输入..." />
        </el-form-item>
        <el-form-item label="发布时间" prop="publishTime">
          <el-date-picker v-model="ruleForm.publishTime" placeholder="选择时间" style="width: 100%;" type="datetime" />
        </el-form-item>
        <el-form-item label="辟谣机构" prop="organization" maxlength="249">
          <el-input v-model.trim="ruleForm.organization" placeholder="请输入..." />
        </el-form-item>
        <el-form-item label="内容截图" prop="contentImgUrl">
          <el-upload
            :action="cfg.apiDomain + '/fileUpload/upload?fileType=1'"
            list-type="picture-card"
            :file-list="fileList"
            :limit="3"
            accept="image/*"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
        <el-form-item label="上报内容" prop="content">
          <el-input
            v-model.trim="ruleForm.content"
            type="textarea"
            placeholder="请输入，1000字以内..."
            maxlength="999"
            :autosize="{ minRows: 4 }"
          />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="ruleForm.phone" placeholder="手机号" style="width: 20%;margin-right:20px;" maxlength="11" />
          <el-button
            type="primary"
            :disabled="verifyCodeSendButtonDisabled"
            @click.native="sendVerifyCode()"
          >
            {{ verifyCodeText }}
          </el-button>
        </el-form-item>
        <el-form-item label="短信验证码" prop="verifyCode">
          <el-input v-model.trim="ruleForm.verifyCode" placeholder="短信验证码" style="width: 16%;" maxlength="6" />
        </el-form-item>
        <el-form-item class="submit-item">
          <div class="btn-wrapper">
            <el-button type="info" class="publish-btn" @click="submitForm('ruleForm')">提交</el-button>
          </div>
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { reportSave, getVerifyCode } from '@/api/publish-piyao'
export default {
  data() {
    return {
      ruleForm: {
        articleUrl: '', // 文章地址
        articleTitle: '', // 文章标题
        sourceType: '', // 来源类型（0、网站     1、APP    2、微博   3、微信）
        articleSource: '', // 文章来源
        publishTime: '', // 发文时间（时间戳）
        organization: '', // 辟谣机构
        contentImgUrl: '', // 内容截图
        content: '', // 上报内容
        phone: '', // 手机号
        verifyCode: '' // 验证码
      },
      rules: {
        articleUrl: [
          { required: true, message: '请输入文章链接', trigger: 'blur' }
        ],
        articleTitle: [
          { required: true, message: '请输入文章标题', trigger: 'change' }
        ],
        sourceType: [
          { required: true, message: '请选择来源类型', trigger: 'change' }
        ],
        articleSource: [
          { required: true, message: '请输入文章来源', trigger: 'change' }
        ],
        publishTime: [
          { type: 'date', required: true, message: '请选择发文时间', trigger: 'change' }
        ],
        organization: [
          { required: true, message: '请输入辟谣机构', trigger: 'change' }
        ],
        contentImgUrl: [
          { required: true, message: '请上传内容截图', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入上报内容', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请填写手机号', trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      verifyCodeSendButtonDisabled: false,
      verifyCodeCountDown: 61,
      verifyCodeText: '获取短信验证码',
      // 图片
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: []
    };
  },
  methods: {
    submitForm(formName) {
      if (this.fileList.length) {
        this.ruleForm.contentImgUrl = this.fileList.map(item => {
          console.log('%c 🍚 item: ', 'font-size:20px;background-color: #F5CE50;color:#fff;', item);
          return item.response.result.url
        }).join(',')
        console.log('%c 🍠 this.ruleForm.contentImgUrl: ', 'font-size:20px;background-color: #465975;color:#fff;', this.ruleForm.contentImgUrl);
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          reportSave(this.ruleForm).then(res => {
            this.$message.success('提交成功');
            this.$refs[formName].resetFields();
            this.fileList = [];
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    sendVerifyCode() {
      this.$refs.ruleForm.validateField('phone', errorMessage => {
        if (!errorMessage) {
          getVerifyCode(this.ruleForm.phone).then(res => {
            this.verifyCodeSendButtonDisabled = true
            const interval = setInterval(() => {
              this.verifyCodeText = `${this.verifyCodeCountDown}s后重发`
              this.verifyCodeCountDown -= 1
              if (this.verifyCodeCountDown <= 0) {
                this.verifyCodeText = '重新发送'
                this.verifyCodeCountDown = 61
                this.verifyCodeSendButtonDisabled = false
                clearInterval(interval)
              }
            }, 1000)
            this.$nextTick(() => {
              this.$refs.verifyCode.focus()
            })
          })
        } else {
          console.log('验证失败')
        }
      })
    },
    // 上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(res, file, fileList) {
      console.log('%c 🌭 fileList: ', 'font-size:20px;background-color: #33A5FF;color:#fff;', fileList);
      this.fileList = fileList
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 张图片，本次选择了 ${files.length} 个张图片，共选择了 ${fileList.length} 个图片`);
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .form-wrapper {
    margin: 0 auto;
    padding: 30px 0 0;
    width: 900px;

    /deep/ .el-form-item__label {
      color: #333;
      display: inline-block;
      white-space: nowrap;
      font-size: 18px;
      text-align: right;
      font-weight: normal;
      box-sizing: border-box;
      padding-right: 40px;
    }
  }

  .btn-wrapper {
    text-align: center;
    .publish-btn {
      width: 200px;
      margin: 0 auto;
    }
  }
}

@media screen and (max-width: 768px) {
  .container {
    .form-wrapper {
      width: 100%;
      padding: 40px 12px 40px;
      box-sizing: border-box;

      /deep/ .el-form {
        width: 100%;
        padding: 0;
      }

      /deep/ .el-form-item {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        width: 100%;
        box-sizing: border-box;

        &::before,
        &::after {
          display: none;
        }

        .el-form-item__label {
          width: 72px !important;
          padding-right: 2px;
          padding-left: 0;
          font-size: 14px;
          line-height: 1.4;
          text-align: left;
          box-sizing: border-box;
          flex-shrink: 0;
        }

        .el-form-item__content {
          margin-left: 0 !important;
          flex: 1;
          min-width: 0;
          display: flex;
          align-items: center;
          line-height: normal;
          box-sizing: border-box;

          .el-input,
          .el-select,
          .el-textarea,
          .el-date-editor {
            width: auto !important;
            flex: 1;
            max-width: 100%;
            margin-right: 0 !important;
          }

          .el-button {
            width: auto;
            padding: 10px 12px;
            margin-left: 8px;
            white-space: nowrap;
            flex-shrink: 0;
            font-size: 13px;
          }

          .el-upload--picture-card {
            width: 80px;
            height: 80px;
            line-height: 80px;
          }
          .el-upload-list--picture-card .el-upload-list__item {
            width: 80px;
            height: 80px;
          }
        }

        &.submit-item {
          display: block !important;
          margin-top: 30px;

          .el-form-item__content {
            display: block !important;
            margin-left: 0 !important;
            text-align: center;
            width: 100% !important;

            .btn-wrapper {
               width: 100%;
               padding: 0;
               text-align: center;
               display: flex;
               justify-content: center;

               .publish-btn {
                 width: 90% !important;
                 max-width: 90%;
                 display: block;
                 height: 44px;
                 font-size: 16px;
                 margin: 0 auto;
               }
            }
          }
        }
      }
    }
  }
}
</style>
